import 'css-chunksrc/client/common/filterMenu/resourceGroups/group/styles.scss';export default {
  "group": "_group_v149o_1",
  "name": "_name_v149o_11"
};